var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelTumblrFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#35465C",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m10.448 6.89 1.201-.033-.065 2.46h2.987v1.948l-2.987-.032.033 2.907c.341 1.918 2.245 1.253 2.954.575v1.63c-.55.43-1.642.754-2.532.798-1.532-.162-2.845-.652-2.922-3.003v-2.875h-.974V9.35c1.254-.08 2.388-.362 2.305-2.46"
}))));
export default SvgGemChannelTumblrFilled;